import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const VoyahFreeGridEditor = () => {
  const [form, setForm] = useState({
    topRightTitleEn: "",
    topRightTitleAr: "",
    topRightTitleKu: "",

    topRightDescEn: "",
    topRightDescAr: "",
    topRightDescKu: "",

    bottomLeftTitleEn: "",
    bottomLeftTitleAr: "",
    bottomLeftTitleKu: "",

    bottomLeftDescEn: "",
    bottomLeftDescAr: "",
    bottomLeftDescKu: "",

    buttonTextEn: "",
    buttonTextAr: "",
    buttonTextKu: "",
  });

  const [images, setImages] = useState({
    topLeft: null,
    bottomRight: null,
  });

  const [loading, setLoading] = useState(true);

  // MODAL
  const [showModal, setShowModal] = useState(false);
  const [uploadTarget, setUploadTarget] = useState(null);
  const [uploadFile, setUploadFile] = useState(null);

  const resolveUrl = (u) =>
    u?.startsWith("http") ? u : `${API_BASE}${u}`;

  // ==================================================
  // LOAD FROM BACKEND FOR ALL LANGUAGES
  // ==================================================
  useEffect(() => {
    const load = async () => {
      try {
        const [en, ar, ku] = await Promise.all([
          axios.get(`${API_BASE}/api/VFGridSection?lang=en`),
          axios.get(`${API_BASE}/api/VFGridSection?lang=ar`),
          axios.get(`${API_BASE}/api/VFGridSection?lang=ku`),
        ]);

        setForm({
          topRightTitleEn: en.data.topRightTitle,
          topRightDescEn: en.data.topRightDesc,
          bottomLeftTitleEn: en.data.bottomLeftTitle,
          bottomLeftDescEn: en.data.bottomLeftDesc,
          buttonTextEn: en.data.buttonText,

          topRightTitleAr: ar.data.topRightTitle,
          topRightDescAr: ar.data.topRightDesc,
          bottomLeftTitleAr: ar.data.bottomLeftTitle,
          bottomLeftDescAr: ar.data.bottomLeftDesc,
          buttonTextAr: ar.data.buttonText,

          topRightTitleKu: ku.data.topRightTitle,
          topRightDescKu: ku.data.topRightDesc,
          bottomLeftTitleKu: ku.data.bottomLeftTitle,
          bottomLeftDescKu: ku.data.bottomLeftDesc,
          buttonTextKu: ku.data.buttonText,
        });

        setImages({
          topLeft: en.data.topLeftImg,
          bottomRight: en.data.bottomRightImg,
        });

        setLoading(false);
      } catch (err) {
        console.error("Error loading VFGridSection:", err);
      }
    };

    load();
  }, []);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  // ==================================================
  // SAVE TEXTS
  // ==================================================
  const handleSave = async () => {
    const token = localStorage.getItem("token");

    try {
      await axios.put(`${API_BASE}/api/VFGridSection/1`, form, {
        headers: { Authorization: `Bearer ${token}` },
      });

      alert("Updated successfully!");
    } catch (err) {
      console.error(err);
      alert("Update failed");
    }
  };

  // ==================================================
  // UPLOAD MEDIA
  // ==================================================
  const handleUploadImage = async () => {
    if (!uploadFile) return alert("Select a file first.");

    const token = localStorage.getItem("token");
    const fd = new FormData();

    if (uploadTarget === "topLeft") fd.append("TopLeftImage", uploadFile);
    if (uploadTarget === "bottomRight") fd.append("BottomRightImage", uploadFile);

    try {
      await axios.post(`${API_BASE}/api/VFGridSection/1/media`, fd, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      alert("Image updated!");
      window.location.reload();
    } catch (err) {
      console.error(err);
      alert("Upload failed.");
    }
  };

  if (loading) return <p>Loading...</p>;

  const LANGS = ["En", "Ar", "Ku"];

  return (
    <div className="container py-4">
      <h2 className="fw-bold mb-4">Voyah FREE – Grid Section Editor</h2>

      {/* ======================================
            TEXT INPUTS (3 LANGS)
      ======================================= */}
      <div className="row">
        {LANGS.map((l) => (
          <div className="col-lg-4 col-md-6 mb-4" key={l}>
            <div className="card shadow-sm border-0 h-100">
              <div className="card-body">
                <h5 className="text-primary mb-3">{l} Version</h5>

                {/* TOP RIGHT TITLE */}
                <label className="form-label">Top Right Title</label>
                <input
                  className="form-control mb-2"
                  name={`topRightTitle${l}`}
                  value={form[`topRightTitle${l}`]}
                  onChange={handleChange}
                />

                {/* TOP RIGHT DESCRIPTION */}
                <label className="form-label">Top Right Description</label>
                <textarea
                  rows={3}
                  className="form-control mb-3"
                  name={`topRightDesc${l}`}
                  value={form[`topRightDesc${l}`]}
                  onChange={handleChange}
                />

                {/* BOTTOM LEFT TITLE */}
                <label className="form-label">Bottom Left Title</label>
                <input
                  className="form-control mb-2"
                  name={`bottomLeftTitle${l}`}
                  value={form[`bottomLeftTitle${l}`]}
                  onChange={handleChange}
                />

                {/* BOTTOM LEFT DESCRIPTION */}
                <label className="form-label">Bottom Left Description</label>
                <textarea
                  rows={3}
                  className="form-control mb-3"
                  name={`bottomLeftDesc${l}`}
                  value={form[`bottomLeftDesc${l}`]}
                  onChange={handleChange}
                />

                {/* BUTTON TEXT */}
                <label className="form-label">Button Text</label>
                <input
                  className="form-control"
                  name={`buttonText${l}`}
                  value={form[`buttonText${l}`]}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* SAVE BUTTON */}
      <div className="text-end mb-4">
        <button className="btn btn-primary px-4" onClick={handleSave}>
          Save Changes
        </button>
      </div>

      {/* ======================================
            IMAGE BLOCKS
      ======================================= */}
      <h4 className="fw-bold mb-3">Images</h4>

      {[
        { key: "topLeft", label: "Top Left Image" },
        { key: "bottomRight", label: "Bottom Right Image" },
      ].map((x) => (
        <div className="card shadow-sm border-0 mb-4" key={x.key}>
          <div className="card-body">
            <h5 className="mb-3">{x.label}</h5>

            {images[x.key] ? (
              <img
                src={resolveUrl(images[x.key])}
                alt=""
                className="w-100 rounded mb-3"
                style={{ maxHeight: "260px", objectFit: "cover" }}
              />
            ) : (
              <p>No image uploaded.</p>
            )}

            <button
              className="btn btn-primary"
              onClick={() => {
                setUploadTarget(x.key);
                setUploadFile(null);
                setShowModal(true);
              }}
            >
              Upload / Replace
            </button>
          </div>
        </div>
      ))}

      {/* ======================================
            MODAL
      ======================================= */}
      {showModal && (
        <>
          <div className="modal fade show" style={{ display: "block" }}>
            <div className="modal-dialog">
              <div className="modal-content shadow">
                <div className="modal-header">
                  <h5 className="modal-title">
                    Upload {uploadTarget} Image
                  </h5>
                  <button
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  />
                </div>

                <div className="modal-body">
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control"
                    onChange={(e) => setUploadFile(e.target.files[0])}
                  />
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn btn-primary"
                    onClick={handleUploadImage}
                  >
                    Upload
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show" />
        </>
      )}
    </div>
  );
};

export default VoyahFreeGridEditor;
